import React, { useState, useEffect } from 'react';
import RiskInsightsDashboard from './RiskInsightsDashboard';
import Login from './Login';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Check if user was previously authenticated
  useEffect(() => {
    const auth = localStorage.getItem('anvl_auth');
    if (auth === 'true') {
      setIsAuthenticated(true);
    }
  }, []);

  const handleLogin = () => {
    localStorage.setItem('anvl_auth', 'true');
    setIsAuthenticated(true);
  };

  return isAuthenticated ? (
    <RiskInsightsDashboard />
  ) : (
    <Login onLogin={handleLogin} />
  );
}

export default App;